<div class="fc-author-header">&nbsp;</div>
<h1 [innerHtml]="page.name"></h1>
<fc-disclaimer *ngIf="disclosure" [message]="disclosure" [showLink]="showGenericLink"></fc-disclaimer>
<div class="fc-author-description" [innerHtml]="page.description | marked"></div>
<h2>Published Articles</h2>
<fc-display-articles [articles]="page.articles"></fc-display-articles>